/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Setting_SavedInputs */

const fr_extra_session_setting_saved = /** @type {(inputs: Extra_Session_Setting_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réglage enregistré`)
};

/**

* @param {Extra_Session_Setting_SavedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_setting_saved = /** @type {((inputs?: Extra_Session_Setting_SavedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Setting_SavedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_setting_saved(inputs)
});